import { useLocale } from '../../hooks/index';

export const useIntervalFromToday = (date: Date) => {
  const { messagesLocale } = useLocale();
  const today = new Date();
  const diffInTime = today.getTime() - date.getTime();
  const diffInDays = Math.floor(diffInTime / (1000 * 3600 * 24));

  if (diffInDays < 1) {
    return messagesLocale['TODAY'];
  }

  if (diffInDays < 30) {
    return `${diffInDays} d`;
  }

  const diffInMonths = Math.floor(diffInDays / 30);

  if (diffInMonths < 12) {
    return `${diffInMonths} m`;
  }

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};
